import { Button, Container, Grid, IconButton, MenuItem, Typography, useTheme } from "@material-ui/core";
import { Field, FieldProps, Form, Formik } from "formik";
import { DateTimePicker } from "formik-material-ui-pickers";
import { toast } from "react-toastify";
import { useUsers } from "../../../common/CommonQueries";
import { useReportDispostion } from "../../projectManagementQueries";
import { useHistory } from "react-router-dom";
import { useFetchContext } from "../../../common/FetchContext";
import * as Yup from "yup";
import { useAuthContext } from "../../../common/AuthContext";
import { TextField } from "formik-material-ui";
import { useAssignRSD } from "../../../dataEgress/dataEgressMutations";
import { useQueryClient } from "react-query";
import { Delete } from "@material-ui/icons";
import { useRef } from "react";
import React from "react";
import { usePostFile } from "../../../common/services/fileServices";
import LSDBFormikAutocompleteField from "../../../common/LSDBFormikAutocompleteField";
export const EditReportResultsItems = ({ report_data, handleClose }: any) => {
  const history = useHistory();
  const theme = useTheme();
  const { authAxios } = useFetchContext();
  const { mutateAsync: mutateRsd } = useAssignRSD();
  const { state } = useAuthContext();
  const queryClient = useQueryClient();
  const [files, setFiles] = React.useState([]);
  const { mutateAsync: mutatePostFile } = usePostFile();
  const {
    data: users,
    isError: isErrorUsers,
    isLoading: isLoadingUsers,
    error: errorUsers,
  } = useUsers();
  const {
    data: statusDispositions,
    isError: isErrorStatus,
    isLoading: isLoadingStatus,
    error: errorStatus,
  } = useReportDispostion();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleFileUpload = async (item: any) => {
    console.log(item)
    fileInputRef.current?.click()
  };
  const handleFilePicked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles) {
      setFiles(uploadedFiles as any);
    }
  }
  return (
    <div style={theme.container}>
      <Container maxWidth="sm">
        <Grid
          container
          direction="row"
          justify="space-around"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={12}>
            <Formik
              initialValues={{
                id: report_data.id || "",
                report_writer: report_data.report_writer,
                status_disposition: report_data.status_disposition,
                report_approver: report_data.report_approver,
                document_title: report_data.report_type_definition_name + "_" + report_data.project_number + "_" + report_data.work_order_name,
                dueDate: new Date(),
                issueDate: new Date()
              }}
              validationSchema={Yup.object({
                id: Yup.string().required("Report id must be required"),
                report_writer: Yup.string().required("Field must be required"),
                status_disposition: Yup.string().required("Field must be required"),
                report_approver: Yup.string().required("Field must be required"),
              })}
              onSubmit={async (values, { setSubmitting }) => {
                // console.log("Project data", JSON.stringify(values));
                try {
                  if (files.length > 0) {
                    for (let file of files) {
                      const postedFile = await mutatePostFile({ authAxios, file });
                      await mutateRsd({
                        authAxios,
                        report_result_id: report_data.id,
                        report_writer: values.report_writer,
                        status_disposition: values.status_disposition,
                        report_approver: values.report_approver,
                        user_id: state.id,
                        due_date: values.dueDate,
                        issue_date: values.issueDate,
                        azurefile: postedFile.url,
                        document_title: values.document_title,
                      });
                    }
                  } else {
                    await mutateRsd({
                      authAxios,
                      report_result_id: report_data.id,
                      report_writer: values.report_writer,
                      status_disposition: values.status_disposition,
                      report_approver: values.report_approver,
                      user_id: state.id,
                      due_date: values.dueDate,
                      issue_date: values.issueDate,
                    });
                  }

                  toast.success("Report was succesfully changed");
                  setSubmitting(false);
                  queryClient.invalidateQueries(["report_result_data", report_data.work_order_id]);
                  handleClose();
                } catch (error) {
                  toast.error(`Error updating: ${error}`);
                }
              }}
            >
              {({ errors, touched, submitForm }) => {
                console.log("Errors", errors);
                return (
                  <Form onSubmit={submitForm}>
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      alignItems="center"
                      spacing={4}
                    >
                      <Grid item xs={6}>
                        <Field
                          id="report_type"
                          label={report_data.report_type_definition_name}
                          name="report_type"
                          component={TextField}
                          fullWidth
                          variant="outlined"
                          size="small"
                          disabled={true}
                          data-testid="report_type"
                        >
                        </Field>
                      </Grid>
                      <Grid item xs={6}>
                        {/* <Field
                          id="report_writer"
                          label="Select Report Writer"
                          defaultValue={report_data.report_writer}
                          name="report_writer"
                          select={true}
                          fullWidth
                          variant="outlined"
                          size="small"
                          component={TextField}
                          helperText={
                            touched.report_writer ? errors.report_writer : ""
                          }
                          error={
                            touched.report_writer && Boolean(errors.report_writer)
                          }
                        >
                          {users?.map((user: any) => (
                            <MenuItem
                              key={user.url}
                              value={user.url}>
                              {user.username}
                            </MenuItem>
                          ))}
                        </Field> */}
                        <LSDBFormikAutocompleteField
                          fieldId="report_writer"
                          fieldName="report_writer"
                          fieldDisplayName="Select Report Writer"
                          options={users}
                          getOptionLabel={(user: any) => user.username}
                          getOptionValue={(user: any) => user.url}
                          fullWidth={true}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          id="status_disposition"
                          label="Select Status"
                          name="status_disposition"
                          defaultValue={report_data.status_disposition}
                          select={true}
                          fullWidth
                          component={TextField}
                          variant="outlined"
                          size="small"
                          helperText={
                            touched.status_disposition ? errors.status_disposition : ""
                          }
                          error={
                            touched.status_disposition && Boolean(errors.status_disposition)
                          }
                        >
                          {statusDispositions?.map((status: any) => (
                            <MenuItem
                              key={status.id}
                              value={status.id}>
                              {status.name}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          name="dateTimeDue"
                          component={DateTimePicker}
                          format="YYYY-MM-DD"
                          label="Due Date"
                          inputVariant="outlined"
                          fullWidth
                          size="small"
                          data-testid="dateDueId"
                          helperText={
                            touched.dueDate ? errors.dueDate : ""
                          }
                          error={
                            touched.dueDate && Boolean(errors.dueDate)
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h5" color="primary" >Upload File  <img onClick={handleFileUpload} src="/file_upload.svg" alt="Custom Icon" width="30" height="30" /></Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <input
                          ref={fileInputRef}
                          type="file"
                          style={{ display: 'none' }}
                          accept=".docx"
                          onChange={handleFilePicked}
                        />
                        {files.length != 0 && <div style={{ position: "relative", display: "inline-block" }}>
                          <img src="/file_icon.png" alt="Custom Icon" height={200} width={200} />
                          <IconButton
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              background: "lightgray",
                              color: "black",
                              border: "none",
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                            }}
                            onClick={() => setFiles([])}
                          >
                            <Delete></Delete></IconButton>
                        </div>
                        }
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          id="document_title"
                          label={"Document Title"}
                          defaultValue={report_data.report_type_definition_name + "_" + report_data.project_number + "_" + report_data.work_order_name}
                          disabled={true}
                          name="document_title"
                          component={TextField}
                          fullWidth
                          variant="outlined"
                          size="small"
                        >
                        </Field>
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          name="dateTimeIssue"
                          component={DateTimePicker}
                          format="YYYY-MM-DD"
                          label="Issue Date"
                          inputVariant="outlined"
                          fullWidth
                          size="small"
                          data-testid="dateIssueId"
                          helperText={
                            touched.issueDate ? errors.issueDate : ""
                          }
                          error={
                            touched.issueDate && Boolean(errors.issueDate)
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        {/* <Field
                          id="report_approver"
                          label="Select Report Approver"
                          name="report_approver"
                          defaultValue={report_data.report_approver}
                          select={true}
                          component={TextField}
                          fullWidth
                          variant="outlined"
                          size="small"
                          helperText={
                            touched.report_approver ? errors.report_approver : ""
                          }
                          error={
                            touched.report_approver && Boolean(errors.report_approver)
                          }
                        >
                          {users?.map((user: any) => (
                            <MenuItem
                              key={user.url}
                              value={user.url}>
                              {user.username}
                            </MenuItem>
                          ))}
                        </Field> */}
                        <LSDBFormikAutocompleteField
                          fieldId="report_approver"
                          fieldName="report_approver"
                          fieldDisplayName="Select Report Approver"
                          options={users}
                          getOptionLabel={(user: any) => user.username}
                          getOptionValue={(user: any) => user.url}
                          fullWidth={true}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      alignItems="center"
                      spacing={4}
                    >
                      <Grid item xs={12} >
                        <Button
                          data-testid="submitReportId"
                          variant="contained"
                          color="primary"
                          fullWidth
                          onClick={submitForm}
                        >
                          UPDATE RSD
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}



